/**
 * App plugins registered from the application entry (main bootstrap).
 */

// Plugins
import pinia from '@core/store';
import i18n from '@core/plugins/i18n';
import vueDebounce from 'vue-debounce';
import {registerDocumentRouteSync} from '@core/router/documentRouteSync';

// Types
import type {App} from 'vue';

export async function registerPlugins(app: App) {
  // Pinia must be installed first: the router module calls ModulesService.getModules()
  // at load time, which uses stores. So we install Pinia then dynamically import the router.
  app.use(pinia);

  const {default: router} = await import('@core/router/coreRouter');
  app
    .use(router)
    .use(i18n)
    .directive('debounce', vueDebounce({lock: true}));

  registerDocumentRouteSync(router, i18n);
}
